<template>
  <div class="row">
    <div class="col-12">
      <label :for="`${id}-inputfile`">{{title}}</label>
      <div class="input-group custom-file">
        <input type="file"
          class="custom-file-input"
          accept=".pdf"
          :id="`${id}-inputfile`"
          :name="name"
          ref="inputfile"
          :required="required"
          :readonly="readonly"
          :disabled="disabled"
          v-on:input="$emit('input', showVal($event));"
        />
  <label :for="`${id}-inputfile`" :id="`${id}-inputfile-text`" class="custom-file-label" data-browse="Anexar arquivo..."></label>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {"title": String, "name": String, "id": String, "data-type": String, "required": {
    type: Boolean,
    default: true
  },
  "readonly": {
    type: Boolean,
    default: true
  },
  "disabled": {
    type: Boolean,
    default: true
  },
    "height": {
    type: String,
    default:"height: 184px"
  },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      actualVal: this.value,
    }
  },

 mounted() {
            $('.custom-file-input').on('change', function() {
                let fileName = $(this).val().split('\\').pop();
                $(this).next('.custom-file-label').html((fileName != "" ? fileName : "Escolher Arquivo"));
            });
},

methods:{
  showVal(event) {
    if(typeof(event.target.files[0]) !== 'undefined' ){
    this.actualVal = event.target.files[0]
    return event.target.files[0]
    } 

    else if(typeof(event.target.files[0]) == 'undefined' ){
      this.actualVal = ""
      return ""
    } 
  }
}
};
</script>

<style scoped>
  
</style>
